import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Tag, Tooltip } from '@/components/atoms';

type TagListProps = {
  tags: string[];
  maxVisible?: number;
};

export const TagList: FC<TagListProps> = ({ tags, maxVisible = 3 }) => {
  const { t } = useTranslation('components');

  if (tags.length === 0) {
    return <p className="text-custom-warm-grey-400">{t('tagList.noTags')}</p>;
  }

  const visibleTags = tags.slice(0, maxVisible);
  const hiddenTags = tags.slice(maxVisible);
  const hasMoreTags = hiddenTags.length > 0;

  return (
    <div className="flex items-center gap-2">
      {visibleTags.map(tag => (
        <Tag key={tag} label={tag} size="regular" color="cyan" />
      ))}
      {hasMoreTags && (
        <Tooltip
          title={
            <div className="flex flex-wrap gap-2 justify-center">
              {hiddenTags.map(tag => (
                <Tag key={tag} label={tag} size="regular" color="cyan" />
              ))}
            </div>
          }
        >
          +{hiddenTags.length}
        </Tooltip>
      )}
    </div>
  );
};
